import IpsBadge from './IpsBadge.vue';
import '../../../styles/custom.scss';

export default IpsBadge;
